module.exports = __webpack_public_path__ + "static/media/user_result_icon.81f57c35.svg";